import { ChartMetadata, ChartPlugin, Behavior, t } from '@superset-ui/core';
import transformProps from './transformProps';
import controlPanel from './controlPanel';
import buildQuery from './buildQuery';
import thumbnail from './images/thumbnail.png';

// В Superset 4.x проверка на cross-filtering/scoping идет именно по Behavior.InteractiveChart
// (а не по старому Behavior.INTERACTIVE_CHART).
// Делаем fallback, чтобы не ломаться на разных версиях enum.
const INTERACTIVE_BEHAVIOR =
  (Behavior as any).InteractiveChart ?? (Behavior as any).INTERACTIVE_CHART;

export default class FilterSelectorPlugin extends ChartPlugin {
  constructor() {
    super({
      metadata: new ChartMetadata({
        name: t('Filter selector'),
        description: t('Compact filter controls that emit cross-filters'),
        behaviors: INTERACTIVE_BEHAVIOR ? [INTERACTIVE_BEHAVIOR] : [],
        enableNoResults: false,
        thumbnail,
      }),
      buildQuery,
      loadChart: () => import('./Chart'),
      transformProps,
      controlPanel,
    });
  }
}
